import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Only from "react-only-when";
import { PlaceHolder } from "../common";
import {
  Header,
  BookingRating,
  Rooms,
  Prices,
  Notes,
  Dates,
  Divider
} from "./";
import styles from "./styles.less";

class Cart extends Component {
  componentDidMount() {
    window.silverbyteDOM.searchbox &&
      window.silverbyteDOM.searchbox.unmount(document.querySelector("#sbox"));
  }

  componentWillUnmount() {
    window.silverbyteDOM.searchbox &&
      window.silverbyteDOM.searchbox.mount(document.querySelector("#sbox"));
  }

  getNotesArr = () => {
    const { discountClubConfig, clubUserLoggedIn, titles } = this.props;

    let arr = [];
    if (titles.CartPayArrival) {
      arr.push(titles.CartPayArrival);
    }
    if (titles.CustomerRequestCartTitle) {
      arr.push(titles.CustomerRequestCartTitle);
    }
    if (titles.CustomerRequestCartTitle2) {
      arr.push(titles.CustomerRequestCartTitle2);
    }
    if (clubUserLoggedIn) {
      arr.push(
        titles.CartDiscountPercent &&
          titles.CartDiscountPercent.replace(
            "%",
            discountClubConfig.Percentage + "%"
          )
      );
    }

    return arr;
  };

  render() {
    const {
      items,
      isRtl,
      titles,
      propertyType,
      propertyName,
      globalCurrency,
      globalCurrencyCode,
      selectedCurrency,
      clubUserLoggedIn,
      totalPrices,
      clubTotalPrices,
      promoCode,
      isPromoCodeValid,
      checkinDate,
      checkoutDate,
      bookingRates,
      showCancellationPolicy,
      onShowCancellationPolicy,
      onAddonRemove,
      onNewSearchClick,
      isMobileView,
      placeHolders,
      displayPriceWithoutTaxes,
      taxesPrecentage,
      ignoreClubDueToPromoCode
    } = this.props;
    let { bookingRatesEnabled } = this.props;

    const hasAnySelections = Boolean(items && items.length > 0);
    const hasPromocode = promoCode != "" && promoCode.length > 0;
    const hasPrice = Boolean(
      totalPrices.totalPrice && totalPrices.totalPrice > 0
    );

    const validBookingRate =
      bookingRates && bookingRates.general && bookingRates.general.score;

    bookingRatesEnabled = Boolean(bookingRatesEnabled && validBookingRate);

    return (
      <div
        className={cx(styles.cart, {
          [styles.rtl]: isRtl,
          [styles.mobileView]: isMobileView
        })}
      >
        <Header
          className={styles.header}
          titles={titles}
          propertyType={propertyType}
          propertyName={propertyName}
          isMobileView={isMobileView}
        />

        <Only when={bookingRatesEnabled}>
          <BookingRating
            className={styles.bookingRating}
            titles={titles}
            rate={validBookingRate}
            isRtl={isRtl}
            isMobileView={isMobileView}
          />
        </Only>

        <Divider isMobileView={isMobileView} />

        <Only when={hasPromocode}>
          <React.Fragment>
            <div
              className={cx(styles.coupon, {
                [styles.mobileView]: isMobileView
              })}
            >
              <div className={styles.title}>{titles.PromoCode}:</div>
              <div
                className={cx(styles.code, {
                  [styles.unvalid]: !isPromoCodeValid
                })}
              >
                {isPromoCodeValid
                  ? promoCode
                  : titles.TheEnteredCodeIsNotActive}
              </div>
            </div>
            <Divider />
          </React.Fragment>
        </Only>

        <Dates
          className={styles.dates}
          checkin={checkinDate}
          checkout={checkoutDate}
          titles={titles}
          onNewSearchClick={onNewSearchClick}
          isMobileView={isMobileView}
        />

        <Divider isMobileView={isMobileView} />

        <Rooms
          className={styles.rooms}
          isRtl={isRtl}
          rooms={items}
          globalCurrencyCode={globalCurrencyCode}
          titles={titles}
          propertyType={propertyType}
          onAddonRemove={onAddonRemove}
          isMobileView={isMobileView}
        />

        <Prices
          className={styles.prices}
          titles={titles}
          rooms={items}
          currency={globalCurrency}
          currencyCode={globalCurrencyCode}
          selectedCurrency={selectedCurrency}
          globalCurrency={globalCurrency}
          globalCurrencyCode={globalCurrencyCode}
          totalPrices={totalPrices}
          clubTotalPrices={clubTotalPrices}
          propertyType={propertyType}
          hasPrice={hasPrice}
          clubUserLoggedIn={clubUserLoggedIn}
          isMobileView={isMobileView}
          displayPriceWithoutTaxes={displayPriceWithoutTaxes}
          taxesPrecentage={taxesPrecentage}
          ignoreClubDueToPromoCode={ignoreClubDueToPromoCode}
        />

        <Only when={hasAnySelections}>
          <Notes
            className={styles.notes}
            clubUserLoggedIn={clubUserLoggedIn}
            titles={titles}
            notesArr={this.getNotesArr()}
            isMobileView={isMobileView}
          />
        </Only>

        <Only when={showCancellationPolicy && hasPrice}>
          <div
            className={styles.cancelationPolicy}
            onClick={onShowCancellationPolicy}
            onKeyDown={onShowCancellationPolicy}
            tabIndex="0"
            role="button"
          >
            {titles.ReadOurCancelationPolicy}
          </div>
        </Only>
        <PlaceHolder
          placeHolders={placeHolders}
          component={"Cart"}
          location={"Bottom"}
        />
      </div>
    );
  }
}

Cart.defaultProps = {
  items: [],
  propertyType: "hotel",
  showCancellationPolicy: false,
  clubUserLoggedIn: false,
  discountClubConfig: {},
  selectedCurrency: {},
  bookingRatesEnabled: false,
  bookingRates: {},
  isPromoCodeValid: false
};

Cart.propTypes = {
  items: PropTypes.array,
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  propertyType: PropTypes.string,
  propertyName: PropTypes.string,
  selectedCurrency: PropTypes.string,
  globalCurrency: PropTypes.string,
  globalCurrencyCode: PropTypes.string,
  totalPrices: PropTypes.object,
  clubTotalPrices: PropTypes.object,
  clubUserLoggedIn: PropTypes.bool,
  discountClubConfig: PropTypes.object,
  promoCode: PropTypes.string,
  isPromoCodeValid: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  bookingRatesEnabled: PropTypes.bool,
  bookingRates: PropTypes.object,
  onAddonRemove: PropTypes.func,
  showCancellationPolicy: PropTypes.bool,
  onShowCancellationPolicy: PropTypes.func,
  onNewSearchClick: PropTypes.func,
  placeHolders: PropTypes.array,
  displayPriceWithoutTaxes: PropTypes.bool,
  taxesPrecentage: PropTypes.number,
  ignoreClubDueToPromoCode: PropTypes.bool
};

export default Cart;



// WEBPACK FOOTER //
// ./src/components/Cart/Cart.js